import React, { useRef } from "react";
import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import FormInput from "../../components/Formik/FormInput";
import FormSelect from "../../components/Formik/FormSelect";
import CustomButton from "../../components/Buttons/Button";

export const currencyStockOptions = [
  { value: "NGR", label: "Nigerian Naira (₦)" },
  { value: "USD", label: "United State Dollars ($)" },
];

export const trendOptions = [
  { value: "up", label: "Up" },
  { value: "down", label: "Down" },
  { value: "flat", label: "Flat" },
];

export const booleanOptions = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

const bannerStyle = {
  width: "100%",
  maxWidth: "590px",
  height: "auto",
  border: "1px solid #EAECF0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  justifyContent: "center",
  borderRadius: "10px",
  textAlign: "center",
  lineHeight: 1.8,
  cursor: "pointer",
};

const clearIconStyle = {
  position: "absolute",
  top: "0px",
  right: "10px",
  background: "#159AA8",
  borderRadius: "50%",
  padding: "4px",
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.5)",
  cursor: "pointer",
};

function StockForm({
  form,
  loading,
  submitLabel,
  logo,
  setLogo,
  logoPreview,
  setLogoPreview,
  existingLogoUrl,
  onCancel,
}) {
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    if (!e?.dataTransfer?.files?.[0] && !e?.target?.files?.[0]) {
      return;
    }
    const files = e?.dataTransfer?.files || e?.target?.files;
    const file = files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.addEventListener("load", (result) => {
      setLogoPreview(result.target.result);
    });
    setLogo(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleImageChange(e);
  };

  const handleRemoveImage = () => {
    setLogoPreview(null);
    setLogo(null);
  };

  const preview = logoPreview || existingLogoUrl;

  return (
    <div className="p-2">
      {/* <div className="mb-4">
        <h1 className="font-[600] text-base">Stock Logo</h1>
      </div>
      <div className="grid grid-cols-2 gap-5 sm:gap-10">
        <div style={{ width: "100%", marginTop: "10px", position: "relative" }}>
          {preview ? (
            <div
              className="w-[90%] lg:w-[90%] !h-[165px]"
              style={{
                border: "1px solid #EAECF0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "10px",
                position: "relative",
                cursor: "pointer",
              }}
            >
              <IconButton onClick={handleRemoveImage} style={clearIconStyle}>
                <ClearIcon style={{ color: "white" }} />
              </IconButton>
              <img
                src={preview}
                alt="Logo Preview"
                className="object-contain"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          ) : (
            <div
              onDrop={handleDrop}
              onDragOver={(e) => e.preventDefault()}
              onClick={() => fileInputRef.current.click()}
              style={bannerStyle}
              className="mt-3 h-auto sm:!h-[165px]"
            >
              <p className="text-sm mt-4">
                <div className="flex items-center justify-center">
                  <img
                    src="/Assets/upload.png"
                    alt="upload icon"
                    className="w-12 h-12 mr-4"
                  />
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    hidden
                    ref={fileInputRef}
                  />
                </div>
                <span className="text-[#159AA8] mt-2">Click to upload </span>
                or drag and drop
              </p>
              <p className="text-sm">SVG, PNG, JPG, or GIF</p>
            </div>
          )}
        </div>
      </div> */}

      <div className="mb-4 mt-10">
        <h1 className="font-[600] text-base">Stock Details</h1>
      </div>

      <div className="grid sm:grid-cols-3 gap-5 w-full">
        <FormInput
          id="symbol"
          label="Symbol *"
          form={form}
          placeholder="e.g. BXN"
        />
        <FormInput
          id="name"
          label="Name *"
          form={form}
          placeholder="e.g. Bua Exchange Net"
        />
        <div>
          <FormSelect
            id="currency"
            label="Currency *"
            form={form}
            options={currencyStockOptions}
          />
        </div>
        <FormInput
          id="current_price"
          label="Current Price *"
          type="number"
          form={form}
          placeholder="Enter current price"
        />
        <FormInput
          id="available_volume"
          label="Available Volume"
          type="number"
          form={form}
          placeholder="Enter available volume"
        />
        <FormInput
          id="min_volume"
          label="Minimum Volume"
          type="number"
          form={form}
          placeholder="Enter minimum volume"
        />
        {/* <FormInput
          id="min_price"
          label="Minimum Price"
          type="number"
          form={form}
          placeholder="Enter minimum price"
        />
        <FormInput
          id="max_price"
          label="Maximum Price"
          type="number"
          form={form}
          placeholder="Enter maximum price"
        /> */}
        <FormInput
          id="percent_change"
          label="Percent Change"
          type="number"
          form={form}
          placeholder="Enter percent change"
        />
        <div>
          <FormSelect
            id="trend"
            label="Trend *"
            form={form}
            options={trendOptions}
          />
        </div>
        <FormInput
          id="sector"
          label="Sector *"
          form={form}
          placeholder="e.g. Production"
        />
        <FormInput
          id="logo_url"
          label="Logo URL *"
          form={form}
          placeholder="e.g. https://example.com/logo.png"
        />
        <div>
          <FormSelect
            id="is_active"
            label="Active *"
            form={form}
            options={booleanOptions}
          />
        </div>
        <div>
          <FormSelect
            id="is_shariah_compliant"
            label="Shariah Compliant *"
            form={form}
            options={[{ value: 1, label: "Yes" }]}
          />
        </div>
      </div>

      <div className="mt-6">
        <FormInput
          id="description"
          label="Description"
          type="textArea"
          form={form}
          placeholder="Enter a description"
        />
      </div>

      <div className="flex justify-center lg:justify-end items-center mt-6">
        <CustomButton
          variant="outlined"
          customColor="#fff"
          children="Cancel"
          width="100px"
          height="45px"
          padding="10px"
          borderColor="#D0D5DD"
          margin="5px 5px"
          color="#000"
          onClick={onCancel}
        />
        <CustomButton
          variant="contained"
          customColor="#159AA8"
          children={submitLabel}
          width="220px"
          height="45px"
          loading={loading}
          padding="10px"
          margin="15px 0"
          color="#fff"
          onClick={form.handleSubmit}
        />
      </div>
    </div>
  );
}

export default StockForm;
